export default {
    ETH: 'ETH',
    BTC: 'BTC',
    ETH_USDT: 'USDT',
    ETH_TRUE_USD: 'TUSD',
    ETH_USDC: 'USDC',
    ETH_PAX: 'PAX',
    TRX: 'TRX',
    TRX_BTT: 'BTT',
    TRX_USDT: 'USDT',
    LTC: 'LTC',
    USDT: 'USDT',
    DOGE: 'DOGE',
    XVG: 'XVG',
    XRP: 'XRP',
    BSV: 'BSV',
    BCH: 'BCH',
    BTG: 'BTG',
    ETH_DAIM: 'DAIM',
    ETH_DAI: 'SAI',
    ETH_OKB: 'OKB',
    ETH_MKR: 'MKR',
    ETH_KNC: 'KNC',
    ETH_BNT: 'BNT',
    XMR: 'XMR',
    ETH_UAX: 'UAX',
    XLM: 'XLM',
    BNB: 'BNB',
    FIO: 'FIO',
    ETH_ONE: 'ONE',
    ETH_BUSD: 'BUSD',
    ETH_LINK: 'LINK',
    ETH_SUSHI: 'SUSHI',
    ETH_HUOBI: 'HUOBI',
    ETH_UNI: 'UNI',
    ETH_ENJ: 'ENJ',
    ETH_AAVE: 'AAVE',
    ETH_GRT: 'GRT',
    ETH_CRV: 'CRV',
    ETH_MATIC: 'MATIC',
    ETH_OMG: 'OMG',
    ETH_CHZ: 'CHZ',
    ETH_BAT: 'BAT',
    ETH_YFI: 'YFI',
    ETH_ZRX: 'ZRX',
    ETH_SNX: 'SNX',
    ETH_RSR: 'RSR',
    ETH_SXP: 'SXP',
    ETH_CRO: 'CRO',
    ETH_BADGER: 'BADGER',
    ETH_BTC: 'BTC',
    ETH_ALPHA: 'ALPHA',
    ETH_1INCH: '1INCH',
    ETH_BAL: 'BAL',
    ETH_COMP: 'COMP',
    BNB_SMART_CAKE: 'CAKE',
    BNB_SMART_BTC: 'BTC',
    BNB_SMART_ETH: 'ETH',
    BNB_SMART_USD: 'BUSD',
    BNB_SMART_LTC: 'LTC',
    BNB_SMART_DOGE: 'DOGE',
    BNB_SMART_ADA: 'ADA',
    BNB_SMART_LINK: 'LINK',
    BNB_SMART_UNI: 'UNI',
    BNB_SMART_BAT: 'BAT',
    BNB_SMART_SXP: 'SXP',
    BNB_SMART_ALPHA: 'ALPHA',

    UAH: 'UAH',
    RUB: 'RUB',
    USD: 'USD',
    EUR: 'EUR',
    GBP: 'GBP',
    TRY: 'TRY',
    KZT: 'KZT',
    AUD: 'AUD',
    BGN: 'BGN',
    BRL: 'BRL',
    CAD: 'CAD',
    CHF: 'CHF',
    CNY: 'CNY',
    COP: 'COP',
    CZK: 'CZK',
    DKK: 'DKK',
    DOP: 'DOP',
    EGP: 'EGP',
    HKD: 'HKD',
    HRK: 'HRK',
    IDR: 'IDR',
    ILS: 'ILS',
    JOD: 'JOD',
    JPY: 'JPY',
    KES: 'KES',
    KRW: 'KRW',
    KWD: 'KWD',
    LKR: 'LKR',
    MAD: 'MAD',
    MXN: 'MXN',
    MYR: 'MYR',
    NGN: 'NGN',
    NOK: 'NOK',
    NZD: 'NZD',
    OMR: 'OMR',
    PEN: 'PEN',
    PKR: 'PKR',
    PLN: 'PLN',
    RON: 'RON',
    SEK: 'SEK',
    SGD: 'SGD',
    THB: 'THB',
    TWD: 'TWD',
    VND: 'VND',
    ZAR: 'ZAR'
}